export const nbaOfferPopup = `*[_type == "sharedSection" && language == $language] .sections[_type == "nbaOfferPopup"]{ ... }`;
